exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-094497cc!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RepositorioAcordo.vue
// module id = 35
// module chunks = 0